setInterval(function() {

  // Set time variables
  var futureTime = new Date("Sep 20, 2018 08:00:00").getTime();
  var currentTime = new Date().getTime();
  var timeDifference = futureTime - currentTime;
  var numberOfDays = Math.floor(
    timeDifference / (1000 * 60 * 60 * 24)
  );
  var numberOfHours = Math.floor(
    (timeDifference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
  );
  var numberOfMinutes = Math.floor(
    (timeDifference % (1000 * 60 * 60)) / (1000 * 60)
  );
  var numberOfSeconds = Math.floor(
    (timeDifference % (1000 * 60)) / 1000
  );

  // Set text based on amount of time left
  if (numberOfDays == 1) {
    var periodOfDays = 'day';
  } else {
    var periodOfDays = 'days';
  }
  if (numberOfHours == 1) {
    var periodOfHours = 'hour';
  } else {
    var periodOfHours = 'hours';
  }
  if (numberOfMinutes == 1) {
    var periodOfMinutes = 'min';
  } else {
    var periodOfMinutes = 'mins';
  }
  if (numberOfSeconds == 1) {
    var periodOfSeconds = 'sec';
  } else {
    var periodOfSeconds = 'secs';
  }

  // Ensure that time left is at least two numbers long
  if (numberOfDays < 10) {
    numberOfDays = '0' + numberOfDays;
  }
  if (numberOfHours < 10) {
    numberOfHours = '0' + numberOfHours;
  }
  if (numberOfMinutes < 10) {
    numberOfMinutes = '0' + numberOfMinutes;
  }
  if (numberOfSeconds < 10) {
    numberOfSeconds = '0' + numberOfSeconds;
  }

  // Ensure that time left doesn't go below zero
  if (timeDifference < 0) {
    numberOfDays = '00';
    numberOfHours = '00';
    numberOfMinutes = '00';
    numberOfSeconds = '00';
  }

  // Output time left
  document.getElementsByClassName('js-number-days')[0].innerHTML = numberOfDays;
  document.getElementsByClassName('js-period-days')[0].innerHTML = periodOfDays;
  document.getElementsByClassName('js-number-hours')[0].innerHTML = numberOfHours;
  document.getElementsByClassName('js-period-hours')[0].innerHTML = periodOfHours;
  document.getElementsByClassName('js-number-minutes')[0].innerHTML = numberOfMinutes;
  document.getElementsByClassName('js-period-minutes')[0].innerHTML = periodOfMinutes;
  document.getElementsByClassName('js-number-seconds')[0].innerHTML = numberOfSeconds;
  document.getElementsByClassName('js-period-seconds')[0].innerHTML = periodOfSeconds;

}, 1000);
